export default () => ({
  menu__title: {
    paddingLeft: '3.8rem',
    marginBottom: '1rem',
    marginTop: '1rem',
  },
});
